module.exports = __webpack_public_path__ + "static/img/knowledgenew5.e458c504.jpg";